import { Link } from "react-router-dom";
import { areas } from "@/mocks/area";

export default function AreaTeaser() {
  return (
    <section className="px-4 md:px-8 py-12 sm:py-16 md:py-24 bg-background-100">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
        <div>
          <div className="inline-flex items-center gap-2 mb-4 px-3 py-1 rounded-full bg-background-50 border border-background-200 text-[11px] uppercase tracking-[0.18em] text-foreground-700">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            Where I work
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-semibold tracking-tight text-foreground-950 leading-[1.05] max-w-3xl">
            Serving <span className="text-accent-600">Islington</span> and nearby<br />
            <em className="not-italic">North London homes &amp; shops.</em>
          </h2>
        </div>
        <Link
          to="/area"
          className="group inline-flex items-center gap-2 self-start md:self-end px-5 py-3 rounded-full border border-background-300 text-foreground-800 text-sm font-semibold hover:bg-background-50 transition-colors cursor-pointer whitespace-nowrap"
        >
          See service area
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {areas.map((a) => (
          <div
            key={a.name}
            className={`group relative rounded-2xl overflow-hidden ${a.tint} border border-background-200 transition-all duration-300 hover:-translate-y-1`}
          >
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src={a.image}
                alt={`${a.name} neighbourhood`}
                loading="lazy" decoding="async"
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="p-4 md:p-5 bg-background-50">
              <div className="flex items-center justify-between">
                <p className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
                  {a.name}
                </p>
                <span className="text-[11px] uppercase tracking-[0.14em] text-foreground-600">
                  {a.postcodes}
                </span>
              </div>
              <p className="mt-1 text-xs md:text-sm text-foreground-600">{a.note}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}